import React from 'react';
import { MapPin } from 'lucide-react';

const serviceAreas = [
  {
    id: 'surrey',
    city: 'Surrey',
    province: 'British Columbia',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d167485.29673188025!2d-122.90985035!3d49.1044302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5485dc034d0a7697%3A0x5070c60e9f7c0!2sSurrey%2C%20BC%2C%20Canada!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    description: 'Serving Surrey and the Greater Vancouver area',
  },
  {
    id: 'winnipeg',
    city: 'Winnipeg',
    province: 'Manitoba',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d166501.0216830887!2d-97.23947545!3d49.8538426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52ea73fbf91a2b11%3A0x2b2a1afac6b9ca64!2sWinnipeg%2C%20MB%2C%20Canada!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    description: 'Professional installations throughout Winnipeg',
  },
  {
    id: 'calgary',
    city: 'Calgary',
    province: 'Alberta',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d160351.3417498186!2d-114.19025745!3d51.0277382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x537170039f843fd5%3A0x266d3bb1b652b63a!2sCalgary%2C%20AB%2C%20Canada!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    description: 'Bringing beautiful lighting to Calgary and area',
  },
  {
    id: 'red-deer',
    city: 'Red Deer',
    province: 'Alberta',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d76984.95089891498!2d-113.85344645!3d52.2681118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53826d7e9726de65%3A0x5c8a1d87a60e9c68!2sRed%20Deer%2C%20AB%2C%20Canada!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    description: 'Quality LED lighting for Red Deer and Central Alberta',
  },
];

const ServiceAreas = () => {
  return (
    <section className="py-20 bg-zinc-950" data-testid="service-areas-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Our Service Areas
          </h2>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto">
            Proudly serving Western Canada with professional LED lighting installation
          </p>
        </div>

        {/* Service Area Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {serviceAreas.slice(0, 3).map((area) => (
            <div
              key={area.id}
              className="group relative overflow-hidden rounded-2xl bg-zinc-900 border border-zinc-800 hover:border-amber-500/50 transition-all duration-300"
              data-testid={`service-area-${area.id}`}
            >
              {/* Google Map Embed */}
              <div className="relative h-56 overflow-hidden">
                <iframe
                  src={area.mapEmbed}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`Map of ${area.city}, ${area.province}`}
                  className="grayscale hover:grayscale-0 transition-all duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-2">
                  <MapPin className="w-5 h-5 text-amber-500" />
                  <h3 className="text-2xl font-bold text-white">
                    {area.city}
                  </h3>
                </div>
                <p className="text-amber-500 font-medium mb-3">
                  {area.province}
                </p>
                <p className="text-zinc-400 text-sm">
                  {area.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Centered Red Deer Card */}
        <div className="flex justify-center mt-8">
          <div
            className="group relative overflow-hidden rounded-2xl bg-zinc-900 border border-zinc-800 hover:border-amber-500/50 transition-all duration-300 w-full md:w-1/3"
            data-testid="service-area-red-deer"
          >
            {/* Google Map Embed */}
            <div className="relative h-56 overflow-hidden">
              <iframe
                src={serviceAreas[3].mapEmbed}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Map of ${serviceAreas[3].city}, ${serviceAreas[3].province}`}
                className="grayscale hover:grayscale-0 transition-all duration-500"
              />
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="flex items-center gap-2 mb-2">
                <MapPin className="w-5 h-5 text-amber-500" />
                <h3 className="text-2xl font-bold text-white">
                  {serviceAreas[3].city}
                </h3>
              </div>
              <p className="text-amber-500 font-medium mb-3">
                {serviceAreas[3].province}
              </p>
              <p className="text-zinc-400 text-sm">
                {serviceAreas[3].description}
              </p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-zinc-400 mb-6">
            Don't see your area? Contact us — we may still be able to help!
          </p>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-black font-semibold px-8 py-3 rounded-full transition-colors duration-200"
            data-testid="service-areas-cta"
          >
            <MapPin className="w-5 h-5" />
            Get a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
